import { ErrorMessages, MessageCodes, MessageStatus } from '../enums';

const messageCodeMap: { [key: string]: string } = {
  [ErrorMessages.SAME_PHONE]: MessageCodes.SAME_PHONE,
  [ErrorMessages.ALREADY_PHONE]: MessageCodes.ALREADY_PHONE,
};

const messageStatusMap: { [key: string]: string } = {
  updateInProgress: MessageStatus.updateInProgress,
  unlockedForEdit: MessageStatus.unlockedForEdit,
  updateCompleted: MessageStatus.updateCompleted,
  updateFailed: MessageStatus.updateFailed,
};
export const getMessageCode = (message: string): string | null => {
  return messageCodeMap[message] || null;
};

export const getMessageStatusValue = (status: MessageStatus | string): string | null => {
  return messageStatusMap[status];
};
